<template>
<div>
  <SifrarnikPopup v-if="popup_open" @closePopup="popup_open=false;" :flat_radnje="single_row_sifra" :radnje="radnje" :chosen_row="chosen_row"/>
    <div class="entry-main-wrapper entry-troskovnik">
      <DataLoader :is_on="fetching" />
      <div id="scroll-top" class="entry-wrapper new-troskovnik-wrapper">
        <div class="entry-header">
          <div class="entry-header-left">
            <div class="entry-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="84" height="84" version="1.1" viewBox="0 0 84 84"><defs><clipPath id="ClipPath1035"><path d="M42.00195,1.996c22.09246,0 40.00199,17.90946 40.00199,40.00192c0,22.09263 -17.90953,40.00192 -40.00199,40.00192c-22.09246,0 -40.00187,-17.90929 -40.00187,-40.00192c0,-22.09246 17.90941,-40.00192 40.00187,-40.00192z" fill="#ffffff"/></clipPath></defs><desc>Generated with Avocode.</desc><g><g><title>Ellipse 5</title><path d="M42.00195,1.996c22.09246,0 40.00199,17.90946 40.00199,40.00192c0,22.09263 -17.90953,40.00192 -40.00199,40.00192c-22.09246,0 -40.00187,-17.90929 -40.00187,-40.00192c0,-22.09246 17.90941,-40.00192 40.00187,-40.00192z" fill="#f0efff" fill-opacity="0"/><path d="M42.00195,1.996c22.09246,0 40.00199,17.90946 40.00199,40.00192c0,22.09263 -17.90953,40.00192 -40.00199,40.00192c-22.09246,0 -40.00187,-17.90929 -40.00187,-40.00192c0,-22.09246 17.90941,-40.00192 40.00187,-40.00192z" fill-opacity="0" fill="#ffffff" stroke-linejoin="round" stroke-linecap="round" stroke-opacity="1" stroke="#d4d6df" stroke-miterlimit="20" stroke-width="4" clip-path="url(&quot;#ClipPath1035&quot;)"/></g><g><title>icon</title><path d="M33.50471,35.9841c0,-0.46079 0.37336,-0.8343 0.83399,-0.8343h5.33724c0.46062,0 0.83399,0.37351 0.83399,0.8343c0,0.46079 -0.37336,0.8343 -0.83399,0.8343h-5.33724c-0.46051,0 -0.83399,-0.37351 -0.83399,-0.8343zM45.51361,41.40729c0,0.46079 -0.37336,0.8343 -0.83399,0.8343h-10.34093c-0.46062,0 -0.83399,-0.37351 -0.83399,-0.8343c0,-0.46079 0.37336,-0.8343 0.83399,-0.8343h10.34105c0.46051,0 0.83387,0.37351 0.83387,0.8343zM45.51361,46.83047c0,0.46079 -0.37336,0.8343 -0.83399,0.8343h-10.34093c-0.46062,0 -0.83399,-0.37351 -0.83399,-0.8343c0,-0.46079 0.37336,-0.83447 0.83399,-0.83447h10.34105c0.46051,0 0.83387,0.37367 0.83387,0.83447zM55.93787,53.42158c-0.12803,0.06742 -0.27275,0.09646 -0.41699,0.08345c-0.32473,0.01101 -0.64039,-0.10931 -0.87559,-0.33362l-2.54345,-2.29461l-0.50032,0.37551v5.9237c0.03147,0.47698 -0.21124,0.93009 -0.62549,1.16825c-0.42295,0.22764 -0.94807,0.1225 -1.25098,-0.25034l-2.50185,-2.29461l-3.04389,2.71168c-0.47493,0.42491 -1.19305,0.42491 -1.66786,0l-3.00217,-2.71168l-3.00229,2.71168c-0.23103,0.20428 -0.52571,0.3221 -0.83387,0.33379c-0.30971,-0.00417 -0.60689,-0.123 -0.83399,-0.33379l-3.04389,-2.71168l-2.54357,2.29461c-0.37801,0.36333 -0.93806,0.46213 -1.41764,0.25034c-0.46337,-0.21646 -0.77975,-0.65956 -0.83399,-1.16825v-26.32303c0.08726,-1.90725 1.63639,-3.42064 3.54421,-3.46253h1.45936v-1.41842c0,-1.83549 1.70958,-3.17047 3.54433,-3.17047h17.92991c0.07081,-0.002 0.14162,-0.00134 0.21231,0.0015c1.67966,0.06976 2.98476,1.48852 2.91502,3.16896v26.28148c0.03445,0.48866 -0.22888,0.94979 -0.66733,1.16808zM49.93354,56.25843v-25.40545c0,-0.91774 -0.54204,-1.79377 -1.45936,-1.79377h-17.92991c-0.98836,0.03855 -1.79303,0.80776 -1.87635,1.79377v25.40545l2.16818,-1.9191c0.50533,-0.45495 1.26708,-0.47281 1.79303,-0.04156l3.04389,2.71151l3.00217,-2.71151c0.48745,-0.39053 1.18041,-0.39053 1.66798,0l2.96044,2.71151l3.04401,-2.71151c0.46408,-0.42841 1.18458,-0.41006 1.62613,0.04156zM54.94033,25.75456c-0.04935,-0.75853 -0.70417,-1.33364 -1.46246,-1.28424h-17.92991c-0.91732,0 -1.87635,0.58396 -1.87635,1.5017v1.41842h14.80258c1.83475,0 3.12734,1.62704 3.12734,3.46253v18.27195c0.83399,-0.12517 0.91732,-0.04189 1.25086,0.2919l2.08485,1.9191v-25.3639c0.00679,-0.07226 0.00787,-0.14486 0.0031,-0.21746z" fill="#3326ae" fill-opacity="1"/></g></g></svg>
            </div>
            <div class="entry-title">{{ editing_created ? $t("forms.cost_sheet.troskovnik_title2") : $t("forms.cost_sheet.troskovnik_title1") }}</div>
          </div>
          <div class="entry-header-right">
            <a @click="goBack()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
          </div>
        </div>
        <div class="main-entry-form-wrapper">
          <div class="two-row-elements">
              <form-drop-down :label=" $t('forms.cost_sheet.naplata_lbl')" id="vrsta-naplate" ref="vrstaNaplate" :disabled="editing_created"
              :dropImport="vrste_naplate"></form-drop-down>
              <form-input :label="$t('forms.cost_sheet.naslov_lbl')" id="naslov" ref="naslov"></form-input>
          </div>
          <div class="three-row-elements">
            <form-drop-down
              :label="$t('forms.cost_sheet.doc_tyle_lbl')"
              id="tip-dokumenta"
              ref="tipDokumenta"
              :dropImport="first_level_folders"
              v-show="!editing_created"
            ></form-drop-down>
            <form-drop-down
              :label="$t('forms.cost_sheet.spis_lbl')"
              id="vezani-spis"
              ref="vezaniSpis"
              :dropImport="spisList"
            ></form-drop-down>
            <form-drop-down
              :label="$t('forms.cost_sheet.za_lbl')"
              id="targetirana-skupina"
              ref="targetiranaSkupina"
              :dropImport="targetirane_skupine"
            ></form-drop-down>
          </div>
          <div class="two-row-elements">
            <form-currency-input  :dropImport="valute" :label="$t('forms.cost_sheet.vps_lbl')" id='troskovnik-vps'
                  ref="valuta" :is_troskovnik="true" :init_case_value="predmet_info.VPS" :init_currency_type="predmet_info.uid_currency">
            </form-currency-input>
            <form-input  :dropImport="valute" :label="$t('forms.cost_sheet.posl_lbl')" id='posl-br'
                ref="poslBr">
            </form-input>
          </div>
          <div class="three-row-elements">
            <div class="form-input-wrapper form-date">
                <label class="form-label" for="vrijeme-pocetka">
                  <span>{{ $t('forms.cost_sheet.date_lbl') }}</span>
                </label>
                <input :class="['form-input', 'date-input']"
                type="date"
                id="datum-zavrsetka"
                ref="datumZavrsetka"
                name="datum-zavrsetka"
                v-model="novi_troskovnik_temp.time_created"/>
            </div>
            <form-input  :dropImport="valute" :label="$t('forms.cost_sheet.oznaka_lbl')" id='oznaka'
                ref="oznaka">
            </form-input>
            <form-input :label="$t('forms.cost_sheet.nadlezno_lbl')" id="nadlezno" ref="nadlezno"></form-input>
          </div>
          <!-- <div class="two-row-elements">
            <form-input label="Oznaka" id="oznaka" ref="oznaka"></form-input>
          </div> -->
          <div class="troskovnik-stranka-protustranka-mainwrapper">
              <TroskovnikOsobeInput :field_naslov.sync="novi_troskovnik_temp.stranke_naslov" :field_osobe.sync="novi_troskovnik_temp.stranke"/>
              <TroskovnikOsobeInput :field_naslov.sync="novi_troskovnik_temp.protustranke_naslov" :field_osobe.sync="novi_troskovnik_temp.protustranke"/>
          </div>
          <div class="total-wrapper">
            <div class="turn-on-vat">
              <div class="form-input-wrapper checkbox">
                <label class="form-label">
                  <span>{{$t('forms.cost_sheet.include_vat')}}</span>
                </label>
                <!-- <div > -->
                  <input
                    v-model="novi_troskovnik_temp.vat_active"
                    type="checkbox"
                    class="form-checkbox"
                  />
                <!-- </div> -->
              </div>
              <div v-show="novi_troskovnik_temp.vat_active" class="form-input-wrapper">
                  <label class="form-label" for="vrijeme-pocetka">
                    <span>{{$t('forms.cost_sheet.vat_value')}}</span>
                  </label>
                  <input :class="['form-input']"
                    type="number"
                    ref="vat_val"
                    id="vat-val"
                    name="vat-val"
                    min="0"
                    max="100"
                    :value="novi_troskovnik_temp.vat_percentage"
                    @input="novi_troskovnik_temp.vat_percentage = $event.target.value"
                    />
              </div>
            </div>
            <div class="total-val">
              <span class="total-title">{{ $t('forms.cost_sheet.total_with_vat') }}</span>
              <span class="total-value">{{getTotal}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span>
              <div >{{novi_troskovnik_temp.text_num_value}}</div>
            </div>
          </div>
          <!-- fiksne stavke -->
          <form-textarea class="opis-usluge" name='opis-usluge' :label="$t('forms.cost_sheet.odvj_usl_lbl')" id="opis-usluge" ref="opisUsluge"/>
          <div v-show="novi_troskovnik_temp.vrsta_naplate.ID != 1 && novi_troskovnik_temp.vrsta_naplate.ID != 4" class="troskovnik-element-title">{{ $t('forms.cost_sheet.fiksne.title') }}</div>
          <div v-show="novi_troskovnik_temp.vrsta_naplate.ID != 1 && novi_troskovnik_temp.vrsta_naplate.ID != 4" class="troskovnik-stavke-wrapper">
              <div class="fiksne-stavke-header">
                  <div class="st st1">{{ $t('forms.cost_sheet.fiksne.h1') }}</div>
                  <div class="st st3">{{ $t('forms.cost_sheet.fiksne.h2') }}</div>
                  <div class="st st2">{{ $t('forms.cost_sheet.fiksne.h3') }}</div>
                  <div class="st st4">{{ $t('forms.cost_sheet.fiksne.h4') }}</div>
              </div>
              <div class="stavke-wrapper">
                  <div v-for="(fiks,key) in novi_troskovnik_temp.fiksne_stavke" :key="key" class="stavke-row">
                      <div class="row-number">{{key+1}}</div>
                      <div class="fiksna-stavka">
                          <div class="stavka-datum st1">
                              <v-menu ref="menu1" v-model="fiks.date_picker_open" :close-on-content-click="false" transition="scale-transition" offset-y
                                max-width="290px" min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                  <input type="text" placeholder="dd.mm.yyyy" readonly :value="getDate(fiks.datum)" v-bind="attrs"
                                    @click="fiks.date_picker_open=true;" v-on="on">
                                </template>
                                <v-date-picker locale="hr" :first-day-of-week="1" v-model="fiks.datum" no-title @input="fiks.date_picker_open=false;"></v-date-picker>
                              </v-menu>
                              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g><g><path fill="#3325ae" d="M27.632 5.472v18.951a3.238 3.238 0 0 1-3.238 3.23H3.238A3.238 3.238 0 0 1 0 24.423V5.472a3.238 3.238 0 0 1 3.238-3.23h1.295V.087h2.16V2.24H20.94V.088h2.159V2.24h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H2.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H23.1V6.55h-2.16V4.395H6.693V6.55H4.533V4.395H3.238a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM4.102 12.47H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zM4.102 21.085H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"/></g></g>
                              </svg>
                          </div>

                          <div class="vertical-divider"></div>
                          <div class="stavka-opis st3">
                            <input type="text" v-model="fiks.tbrovi">
                            <div class="add-napomena add-button add-checkitem" @click="openPopup(fiks)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                <g>
                                  <g>
                                    <path fill="#0acab1"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                    </g>
                                    </g>
                                </svg>
                            </div>
                          </div>
                          <div class="vertical-divider"></div>
                          <input type="text" class="stavka-opis st2" v-model="fiks.opis">
                          <div class="add-napomena add-button remove-item" @click="deleteStavka(fiks)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                  <g><g><path fill="#70707E" d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" /></g></g>
                              </svg>
                          </div>
                          <div class="vertical-divider"></div>
                          <input type="text" class="stavka-iznos st4" v-model="fiks.iznos"  oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                      </div>
                  </div>
              </div>
              <div class="add-new" @click="add_new_fiksna">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc" width="12" height="12" version="1.1" viewBox="0 0 12 12"><defs/><desc>Generated with Avocode.</desc><g><g><title>Shape 544</title><path d="M10.88006,4.71948c-0.14734,-0.14586 -0.32628,-0.2183 -0.5368,-0.2183h-3.28338v0v-3.24824c0,-0.20795 -0.07367,-0.38519 -0.22101,-0.53089c-0.14722,-0.1457 -0.32604,-0.21863 -0.5368,-0.21863h-1.51527c-0.21052,0 -0.38934,0.07293 -0.53668,0.21863c-0.14734,0.1457 -0.22101,0.32294 -0.22101,0.53089v3.24824v0h-3.28338c-0.2104,0 -0.38934,0.07243 -0.53668,0.2183c-0.14746,0.14603 -0.22101,0.3226 -0.22101,0.53072v1.4992c0,0.20828 0.07355,0.38536 0.22101,0.53105c0.14734,0.1457 0.32628,0.21846 0.53668,0.21846h3.28326v0v3.2479c0,0.20812 0.07379,0.38536 0.22113,0.53105c0.14734,0.1457 0.32616,0.2183 0.53668,0.2183h1.51539c0.21064,0 0.38934,-0.0726 0.53668,-0.2183c0.14746,-0.1457 0.22113,-0.32294 0.22113,-0.53105v-3.2479v0h3.28326c0.21064,0 0.38958,-0.07277 0.5368,-0.21846c0.14734,-0.1457 0.22101,-0.32277 0.22101,-0.53105v-1.4992c0,-0.20812 -0.07367,-0.38502 -0.22101,-0.53072z" fill="#7b7b8a" fill-opacity="1"/></g></g></svg>
                  <span>{{ $t('forms.cost_sheet.fiksne.add_new') }}</span>
              </div>
              <div class="subtotal-wrapper">
                    <div class="subtotal-value"><span>{{ $t('forms.cost_sheet.fiksne.subtotal') }}</span><span>{{(getFiksneValue).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span></div>
                    <div class="subtotal-value"><span>{{ $t('forms.cost_sheet.fiksne.vat',{value:novi_troskovnik_temp.vat_percentage}) }}</span><span>{{getFiksneVAT}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span></div>
                    <div class="subtotal-value"><span>{{ $t('forms.cost_sheet.fiksne.total') }}</span><span>{{(getFiksneValue*(1+this.novi_troskovnik_temp.vat_percentage/100)).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span></div>
              </div>
          </div>

          <!-- po uspjehu -->
          <div v-if="novi_troskovnik_temp.vrsta_naplate.ID != 2 && novi_troskovnik_temp.vrsta_naplate.ID != 4" class="troskovnik-element-title">{{ $t('forms.cost_sheet.uspjeh.title') }}</div>
          <div v-if="novi_troskovnik_temp.vrsta_naplate.ID != 2 && novi_troskovnik_temp.vrsta_naplate.ID != 4" class="troskovnik-stavke-wrapper">
              <div class="subtotal-wrapper">
                  <div class="troskovnik-element-subtitle">{{ $t('forms.cost_sheet.uspjeh.iznos') }}</div>
                  <div class="po-uspjehu-input">
                      <span class="troskovnik-element-title">{{ $t('forms.cost_sheet.uspjeh.value') }}</span>
                      <input type="text" class="form-input" v-model="novi_troskovnik_temp.uspjeh.uspjeh_value" oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"/>
                  </div>
                  <div class="po-uspjehu-input">
                      <span class="troskovnik-element-title">{{ $t('forms.cost_sheet.uspjeh.percent') }}</span>
                      <input type="text" class="form-input" v-model="novi_troskovnik_temp.uspjeh.uspjeh_postotak" oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');" />
                  </div>
                  <div class="subtotal-value"><span>{{ $t('forms.cost_sheet.uspjeh.iznos') }}</span><span>{{getUspjehValue.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span></div>
                  <div class="subtotal-value"><span>{{ $t('forms.cost_sheet.uspjeh.vat',{value:novi_troskovnik_temp.vat_percentage}) }}</span><span>{{(getUspjehValue*(this.novi_troskovnik_temp.vat_percentage/100)).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span></div>
                  <div class="subtotal-value"><span>{{ $t('forms.cost_sheet.uspjeh.total') }}</span><span>{{(getUspjehValue*(1+this.novi_troskovnik_temp.vat_percentage/100)).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span></div>
              </div>
          </div>
          <TroskovnikBreakdown ref="breakdown" v-show="(novi_troskovnik_temp.vrsta_naplate.ID == 4)" :service_types="service_types" :team_members="team_members" :stavke.sync="breakdown" :final_satnica_list="novi_troskovnik_temp.satnica" />
          <TroskovnikSatnica v-show="(novi_troskovnik_temp.vrsta_naplate.ID == 4)" @refreshListeners="setTextareaAutoHeight" :stavke.sync="novi_troskovnik_temp.satnica" :breakdowns_list="breakdown" :init_time="getInitTime()" :init_iznos="getInitTotal()" :vat_percentage="novi_troskovnik_temp.vat_percentage" />
          <TroskovnikElement :vat_percentage="novi_troskovnik_temp.vat_percentage" :stavke.sync="novi_troskovnik_temp.prostojbe" :valuta="valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name" :stavka_name="$t('forms.cost_sheet.pristojba_lbl')" :text_name="$t('forms.cost_sheet.pristojba_txt')" :add_text="$t('forms.cost_sheet.pristojba_add')" ref="pristojbe" />
          <TroskovnikElement :vat_percentage="novi_troskovnik_temp.vat_percentage" :pdv="true" :stavke.sync="novi_troskovnik_temp.vjestacenje" :valuta="valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name" :stavka_name="$t('forms.cost_sheet.vjest_lbl')" :text_name="$t('forms.cost_sheet.vjest_txt')" :add_text="$t('forms.cost_sheet.vjest_add')" ref="vjestacenje"/>
          <TroskovnikElement :vat_percentage="novi_troskovnik_temp.vat_percentage" :pdv="true" :stavke.sync="novi_troskovnik_temp.ostali_troskovi" :valuta="valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name" :stavka_name="$t('forms.cost_sheet.troskovi_lbl')" :text_name="$t('forms.cost_sheet.troskovi_txt')" :add_text="$t('forms.cost_sheet.troskovi_add')" ref="ostali"/>
          <!-- *** KREIRAJ BUTTON **** -->
          <div class="total-wrapper place-end">
            <div class="total-val">
              <span class="total-title">{{ $t('forms.cost_sheet.total_with_vat') }}</span>
              <span class="total-value">{{getTotal}} {{valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value) == undefined ? '' : valute.find(val=>val.uid == novi_troskovnik_temp.VPS.drop_value).short_name}}</span>
              <div >{{novi_troskovnik_temp.text_num_value}}</div>
            </div>
          </div>
          <div class="two-row-elements">
            <form-textarea name='napomene' :label="$t('forms.cost_sheet.napomene_lbl')" id="napomene" ref="napomene"></form-textarea>
            <form-input :label="$t('forms.cost_sheet.dospijece')" id="dospijece" ref="dospijece"></form-input>
          </div>
          <div class="two-row-elements">
            <div class="form-input-wrapper">
              <label class="form-label">
                <span>{{ $t('forms.cost_sheet.punomocnik') }}</span>
              </label>
              <input class="form-input" type="text" v-model="novi_troskovnik_temp.punomoćnik_naslov"/>
            </div>
            <div class="form-input-wrapper">
              <label class="form-label">
                <span>{{ $t('forms.cost_sheet.punomocnik_os') }}</span>
              </label>
              <input class="form-input" type="text" v-model="novi_troskovnik_temp.punomoćnik_osoba"/>
            </div>
          </div>
          <div :class="{'fixed-to-bottom single':editing_created}">
            <div class="button-create-wrapper create-case-button">
              <div class="button-default button-create" @click="createPdf">
                {{ $t('forms.cost_sheet.prepare_doc') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="warning_unsaved" width="564px">
        <v-card color="universal-vcard">
            <div class="universal-vdialog-title">
                {{ $t('forms.cost_sheet.unsaved_warning') }}
            </div>
            <div class="vdialog-buttons-wrapper">
            <div class="universal-vdialog-button vbutton-secondary" @click="warning_unsaved = false;"> {{ $t("repetitive.cancel") }} </div>
            <div class="universal-vdialog-button vbutton-primary" @click="continueGoBack()"> {{ $t("repetitive.discard") }} </div>
            </div>
        </v-card>
    </v-dialog>
  </div>
</template>


<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formCurrencyInput from "@/components/formElements/formCurrencyInput.vue"
import TroskovnikElement from "@/components/costSheetComponents/TroskovnikElement.vue"
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import SifrarnikPopup from "@/components/costSheetComponents/sifarnik/SifrarnikPopup.vue";
import auth from "@/services/auth";
import financije from "@/apiCallers/promise_handler_db/financial";
import sifarnik from "@/apiCallers/promise_handler_db/sifarnik";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import DataLoader from '@/components/generalComponents/DataLoader';
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import moment from 'moment';
import formCheckbox from "@/components/formElements/formCheckbox.vue";


import $ from "jquery";
import gsap from "gsap";
import TroskovnikOsobeInput from "@/components/costSheetComponents/TroskovnikOsobeInput.vue";
import TroskovnikBreakdown from "@/components/costSheetComponents/breakdown/TroskovnikBreakdown.vue";
import TroskovnikSatnica from "@/components/costSheetComponents/TroskovnikSatnica.vue";

export default {
  data() {
    return {
        arr_1: this.$t("forms.cost_sheet.arr_1"),
        arr_2: this.$t("forms.cost_sheet.arr_2"),
        arr_3: this.$t("forms.cost_sheet.arr_3"),
        arr_4: this.$t("forms.cost_sheet.arr_4"),
        popup_open:false,
        fetching: false,
        date_picker:false,
        valute: [{uid:-1,short_name:''}],
        vrste_naplate:[],
        targetirane_skupine:[
            {id:1,naziv:this.$t("forms.cost_sheet.targetirane.t1")},
            {id:2,naziv:this.$t("forms.cost_sheet.targetirane.t2")},
            {id:3,naziv:this.$t("forms.cost_sheet.targetirane.t3")},
        ],
        service_types:[],
        novi_troskovnik_temp:{
            stranke_naslov:this.$t("forms.cost_sheet.stranke_naslov"),
            stranke:[],
            protustranke_naslov:this.$t("forms.cost_sheet.protustranke_naslov"),
            protustranke:[],
            vrsta_naplate:{ID:1},
            naslov:{value:''},
            poslBr:{value:''},
            opis_usluge:{value:''},
            napomene:{value:''},
            dospijece:{value:''},
            oznaka:{value:''},
            nadlezno_tijelo:{value:''},
            VPS:{drop_value:1,input_value:0},
            fiksne_stavke:[],
            uspjeh:{
              uspjeh_value:'',
              uspjeh_postotak:'',
            },
            prostojbe:[],
            vjestacenje:[],
            ostali_troskovi:[],
            satnica:[{id: 1, opis:'', time_h:0, time_min:0, iznos:0, vat_iznos:0}],
            total:0,
            chosen_spis:null,
            punomoćnik_naslov:this.$t("forms.cost_sheet.punomoćnik_naslov"),
            punomoćnik_osoba:'',
            targetirana_skupina: {ID:1},
            time_created:'',
            tip_dokumenta:{non_int_id:''},
            text_num_value:'',
            vat_active:true,
            vat_percentage:25
          },
        breakdown:[],
        team_members:[],
        first_level_folders:[],
        is_review:false,
        predmet_info:{},
        chosen_object:null,
        datum:'',
        radnje:[],
        chosen_row:null,
        spisList:[],
        editing_created:false,
        warning_unsaved:false,
        single_row_sifra:[]
    };
  },
  computed:{
    /**
     * Vraća ukupnu vrijednost fiksnih stavki u EUR
     */
    getFiksneValue(){
      return this.novi_troskovnik_temp.fiksne_stavke.reduce(function(prev,next){return prev+Number(next.iznos)},0);
    },
    /**
     * Vraća ukupnu vrijednost PDV-a fiksnih stavki u EUR
     */
    getFiksneVAT(){
      return (this.novi_troskovnik_temp.fiksne_stavke.reduce(function(prev,next){return prev+Number(next.iznos)},0)*(this.novi_troskovnik_temp.vat_percentage/100)).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.");
    },
    /**
     * Vraća ukupnu vrijednost po uspjehu u EUR
     */
    getUspjehValue(){
      return Number(this.novi_troskovnik_temp.uspjeh.uspjeh_value*(this.novi_troskovnik_temp.uspjeh.uspjeh_postotak/100));
    },
    /**
     * Vraća ukupnu vrijednost cijelog troškovnika u EUR
     */
    getTotal(){
      let total = 0;
      //uk fiksne s pdv 25%
      if (this.novi_troskovnik_temp.vrsta_naplate.ID != 1 && this.novi_troskovnik_temp.vrsta_naplate.ID != 4) {
        total+=this.novi_troskovnik_temp.fiksne_stavke.reduce(function(prev,next){return prev+Number(next.iznos)},0)*(1+this.novi_troskovnik_temp.vat_percentage/100);
      }
      if (this.novi_troskovnik_temp.vrsta_naplate.ID != 2 && this.novi_troskovnik_temp.vrsta_naplate.ID != 4) {
        //uk po uspjehu
        total+=Number(this.novi_troskovnik_temp.uspjeh.uspjeh_value*(this.novi_troskovnik_temp.uspjeh.uspjeh_postotak/100))*(1+this.novi_troskovnik_temp.vat_percentage/100);
      }
      if (this.novi_troskovnik_temp.vrsta_naplate.ID == 4) {
        //uk po uspjehu
        total+=this.novi_troskovnik_temp.satnica.reduce(function(prev,next){return prev+Number(next.iznos)+Number(next.vat_iznos)},0);
      }
      total+=this.novi_troskovnik_temp.prostojbe.reduce(function(prev,next){return prev+Number(next.iznos)+Number(next.vat_iznos)},0);
      total+=this.novi_troskovnik_temp.vjestacenje.reduce(function(prev,next){return prev+Number(next.iznos)+Number(next.vat_iznos)},0);
      total+=this.novi_troskovnik_temp.ostali_troskovi.reduce(function(prev,next){return prev+Number(next.iznos)+Number(next.vat_iznos)},0);
      // if (this.novi_troskovnik_temp.VPS.input_value != null) {
      //   total+=this.novi_troskovnik_temp.VPS.input_value;
      // }
      this.novi_troskovnik_temp.total = total;
      this.novi_troskovnik_temp.text_num_value = this.toText(total.toFixed(2).toString().replaceAll('.', ','));
      return total.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1."); 
    }
  },
  methods: {
    /**
     * Dinamički postavlja visinu input elemenata u opisu breakdown stavki
     */
    setTextareaAutoHeight(){
      const tx = document.getElementsByClassName("breakdown-textarea");
      setTimeout(() => {
        for (let i = 0; i < tx.length; i++) {
          tx[i].removeEventListener("input", OnInput, true);
          tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;");
          tx[i].addEventListener("input", OnInput, false);
        }
      }, 50);
        
      function OnInput() {
        this.style.height = 0;
        this.style.height = (this.scrollHeight) + "px";
      }
    },
    /**
     * Vraća ukupno zaračunato vrijeme u satnici u minutama
     */
    getInitTime(){
      return this.breakdown.length>0 ? this.breakdown.reduce(function(prev,next){return prev+Number(parseInt(next.time_h)*60+parseInt(next.time_min))},0) : 0
    },
    /**
     * Vraća ukupnu vrijednost satnice u EUR
     */
    getInitTotal(){
      return this.breakdown.length>0 ? this.breakdown.reduce(function(prev,next){return prev+Number(next.iznos)},0) : 0
    },
    /**
     * Pretvara cijenu u tekstualni oblik
     * @param {Number} cijena 
     */
     toText: function (cijena) {
            if (cijena == "0,00") {
                return ""
            }
            var kune_lipe = cijena.split(",");
            var kune = kune_lipe[0].split("");
            var lipe = kune_lipe[1].split("");
            var konacni_rez_kune = this.extractKune(kune);
            var konacni_rez_lipe = this.extractLipe(lipe);
            var konacno = ""
            //Deklinacija riječi kune
            if ([2, 3, 4].includes(parseInt(kune[kune.length - 1]))) {
                konacni_rez_kune += this.$t("forms.cost_sheet.eura")
            }
            else {
                konacni_rez_kune += this.$t("forms.cost_sheet.eura")
            }
            if (konacni_rez_lipe != "") {
                if ([2, 3, 4].includes(parseInt(lipe[lipe.length - 1]))) {
                    konacni_rez_lipe += this.$t("forms.cost_sheet.eurocenta")
                }
                else {
                    konacni_rez_lipe += this.$t("forms.cost_sheet.eurocenti")
                }
                konacno += konacni_rez_kune;
                konacno += this.$t("forms.cost_sheet.i") + konacni_rez_lipe;
            }
            else {
                konacno += konacni_rez_kune;
            }
            return konacno
        },
        /**
         * Vraća lipe u tekstualnom obliku
         * @param {Number} lipe 
         */
        extractLipe: function (lipe) {
            var konacni_rez_lipe = "";
            for (var i = 0; i < lipe.length; i++) {
                switch (lipe.length - i) {
                    case 1:
                        if ((lipe[i]) > 0) {
                            konacni_rez_lipe += " "
                            konacni_rez_lipe += this.arr_1[lipe[i] - 1]
                        }
                        break;
                    case 2:
                        if ((lipe[i] - 1) > 0) {
                            konacni_rez_lipe += " "
                            konacni_rez_lipe += this.arr_2[lipe[i] - 2]
                        }
                        else if ((lipe[i] - 1) == 0) {
                            konacni_rez_lipe += " "
                            i += 1;
                            konacni_rez_lipe += this.arr_3[lipe[i]]
                        }
                        break;
                }
            }
            return konacni_rez_lipe;
        },
        /**
         * Vraća kune u tekstualnom obliku
         * @param {Number} kune 
         */
        extractKune: function (kune) {
            var konacni_rez_kune = "";
            for (var i = 0; i < kune.length; i++) {
                switch (kune.length - i) {
                    case 1:
                        if ((kune[i]) > 0) {
                            konacni_rez_kune += " "
                            konacni_rez_kune += this.arr_1[kune[i] - 1]
                        }
                        break;
                    case 2:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += " "
                            konacni_rez_kune += this.arr_2[kune[i] - 2]
                        }
                        else if ((kune[i] - 1) == 0) {
                            konacni_rez_kune += " "
                            i += 1;
                            konacni_rez_kune += this.arr_3[kune[i]]
                        }
                        break;
                    case 3:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_4[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto1")
                        }
                        else if ((kune[i] - 1) == 0) {
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto2")
                        }
                        break;
                    case 4:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_4[kune[i] - 1]
                            if ([2, 3, 4].includes(parseInt(kune[i]))) {
                                konacni_rez_kune += this.$t("forms.cost_sheet.tisuce")
                            }
                            else
                                konacni_rez_kune += this.$t("forms.cost_sheet.tisuca")
                        }
                        // else if((kune[i] - 1) == 0  && kune.length >= 5){
                        //   konacni_rez_kune += " tisuću "
                        // }
                        else {
                            konacni_rez_kune += this.arr_4[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.tisuca")
                        }
                        break;
                    case 5:
                        if (kune[i] == 1) {
                            i += 1;
                            konacni_rez_kune += this.arr_3[kune[i]]
                            konacni_rez_kune += this.$t("forms.cost_sheet.tisuca")
                        }
                        else {
                            konacni_rez_kune += this.arr_2[kune[i] - 2]
                            if (kune[i + 1] > 0) {
                                konacni_rez_kune += " "
                            }
                            else {
                                konacni_rez_kune += this.$t("forms.cost_sheet.tisuca")
                                i += 1;
                            }
                        }
                        break;
                    case 6:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_4[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto3")
                        }
                        else if ((kune[i] - 1) == 0) {
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto3")
                        }
                        break;
                    
                        case 7:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_1[kune[i] - 1]
                            if ([2, 3, 4].includes(parseInt(kune[i]))) {
                                konacni_rez_kune += this.$t("forms.cost_sheet.milijuna")
                            }
                            else
                                konacni_rez_kune += this.$t("forms.cost_sheet.milijuna")
                        }
                        // else if((kune[i] - 1) == 0  && kune.length >= 5){
                        //   konacni_rez_kune += " tisuću "
                        // }
                        else {
                            konacni_rez_kune += this.arr_1[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.milijuna")
                        }
                        break;
                    case 8:
                        if (kune[i] == 1) {
                            i += 1;
                            konacni_rez_kune += this.arr_3[kune[i]]
                            konacni_rez_kune += this.$t("forms.cost_sheet.milijuna")
                        }
                        else {
                            konacni_rez_kune += this.arr_2[kune[i] - 2]
                            if (kune[i + 1] > 0) {
                                konacni_rez_kune += " "
                            }
                            else {
                                konacni_rez_kune += this.$t("forms.cost_sheet.milijuna")
                                i += 1;
                            }
                        }
                        break;
                    case 9:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_4[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto3")
                        }
                        else if ((kune[i] - 1) == 0) {
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto3")
                        }
                        break;
                        case 10:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_1[kune[i] - 1]
                            if ([2, 3, 4].includes(parseInt(kune[i]))) {
                                konacni_rez_kune += this.$t("forms.cost_sheet.milijuna")
                            }
                            else
                                konacni_rez_kune += this.$t("forms.cost_sheet.milijardi")
                        }
                        // else if((kune[i] - 1) == 0  && kune.length >= 5){
                        //   konacni_rez_kune += " tisuću "
                        // }
                        else {
                            konacni_rez_kune += this.arr_1[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.milijardi")
                        }
                        break;
                    case 11:
                        if (kune[i] == 1) {
                            i += 1;
                            konacni_rez_kune += this.arr_3[kune[i]]
                            konacni_rez_kune += this.$t("forms.cost_sheet.milijardi")
                        }
                        else {
                            konacni_rez_kune += this.arr_2[kune[i] - 2]
                            if (kune[i + 1] > 0) {
                                konacni_rez_kune += " "
                            }
                            else {
                                konacni_rez_kune += this.$t("forms.cost_sheet.milijardi")
                                i += 1;
                            }
                        }
                        break;
                    case 12:
                        if ((kune[i] - 1) > 0) {
                            konacni_rez_kune += this.arr_4[kune[i] - 1]
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto3")
                        }
                        else if ((kune[i] - 1) == 0) {
                            konacni_rez_kune += this.$t("forms.cost_sheet.sto3")
                        }
                        break;
                        
                }
            }
            return konacni_rez_kune;
        },
    /**
     * Rekurzivno vraća svu djecu objekata iz liste simplified_resp 
     * @param {Array} simplified_resp 
     * @param {String} uid 
     */
    getAllChildren: function (simplified_resp, uid) {
            let main_list = simplified_resp.filter((p) => p.parrent_id == uid);
            main_list.sort((a,b)=>{
                const num_arr_a = a.number.split('.');
                const num_arr_b = b.number.split('.');
                return num_arr_a[num_arr_a.length-1] - num_arr_b[num_arr_b.length-1]; 
            })
            main_list.forEach((p) => {
                p["children"] = this.getAllChildren(simplified_resp, p.uid)
            })
            return main_list;
        },
    /**
     * Briše fiksnu stavku iz liste fiksnih stavki
     * @param {FiksnaStavka} delete_this 
     */
    deleteStavka(delete_this){
      this.novi_troskovnik_temp.fiksne_stavke = this.novi_troskovnik_temp.fiksne_stavke.filter(st=>st != delete_this)
    },
    /**
     * Prepares data for cost sheet preview in PDF and reroutes
     * to ReportPage
     */
    createPdf(){
      let troskovnik={
          // vrsta_naplate:{ID:1},
          stranke:this.novi_troskovnik_temp.stranke,
          protustranke:this.novi_troskovnik_temp.protustranke,
          naslov:this.novi_troskovnik_temp.naslov.value,
          poslBr:this.novi_troskovnik_temp.poslBr.value,
          opis_usluge:this.novi_troskovnik_temp.opis_usluge.value,
          napomene:this.novi_troskovnik_temp.napomene.value,
          dospijece:this.novi_troskovnik_temp.dospijece.value,
          oznaka:this.novi_troskovnik_temp.oznaka.value,
          nadlezno_tijelo:this.novi_troskovnik_temp.nadlezno_tijelo.value,
          // VPS:{drop_value:1,input_value:0},
          fiksne_stavke:this.novi_troskovnik_temp.fiksne_stavke,
          fiksne_uk:{
            uk_no_VAT:this.getFiksneValue,
            VAT:this.getFiksneVAT,
            uk:this.getFiksneValue*(1+this.novi_troskovnik_temp.vat_percentage/100),
          },
          uspjeh:this.novi_troskovnik_temp.uspjeh,
          uspjeh_uk:this.getUspjehValue,
          pristojbe:this.novi_troskovnik_temp.prostojbe,
          pristojbe_uk: this.$refs.pristojbe.getValue,
          vjestacenje:this.novi_troskovnik_temp.vjestacenje,
          vjestacenje_uk: this.$refs.vjestacenje.getValue,
          ostali_troskovi:this.novi_troskovnik_temp.ostali_troskovi,
          ostali_uk:this.$refs.ostali.getValue,
          total:this.novi_troskovnik_temp.total,
          naplata_type:this.novi_troskovnik_temp.vrsta_naplate.ID,
          stranke_naslov:this.novi_troskovnik_temp.stranke_naslov,
          protustranke_naslov:this.novi_troskovnik_temp.protustranke_naslov,
          punomoćnik_naslov:this.novi_troskovnik_temp.punomoćnik_naslov,
          punomoćnik_osoba:this.novi_troskovnik_temp.punomoćnik_osoba,
          time_created:this.novi_troskovnik_temp.time_created,
          parent_id: !this.editing_created ? this.novi_troskovnik_temp.tip_dokumenta.non_int_id : undefined,
          text_num_value: this.novi_troskovnik_temp.text_num_value,
          naplata_po_satnici: this.novi_troskovnik_temp.satnica,
          vat_active:this.novi_troskovnik_temp.vat_active,
          vat_percentage:this.novi_troskovnik_temp.vat_percentage
      }
      this.$store.state.troskovnik_data = troskovnik;
      this.$store.state.edit_troskovnik_data = this.novi_troskovnik_temp;
      this.$store.state.breakdown_satnice = this.breakdown;
      this.$store.state.troskovnik_pdf_view = false;
      this.$store.state.troskovnik_unsaved_changes = true;
      setTimeout(() => {
        this.$router.push('troskovnik-report');
      }, 100);
    },
    /**
     * Otvara novi popup za odabir iz tarife
     * @param {FiksnaStavka} el 
     */
    openPopup(el){
      this.chosen_row = el
      this.popup_open = true;
    },
    /**
     * Warns user if there are unsaved changes
     * or continues rerouting to previous view
     */
    goBack() {
      if (this.$store.state.troskovnik_unsaved_changes || this.editing_created) {
        this.warning_unsaved = true;
      }
      else{
        this.continueGoBack();
      }
    },
    /**
     * Reroutes from current view to previous view if there are unsaved changes
     */
    continueGoBack(){
      this.$store.state.edit_troskovnik_data = null;
      this.$store.state.troskovnik_data = null;
      this.$router.push('naplata');
      this.$store.state.troskovnik_unsaved_changes = false;
      this.$store.state.breakdown_satnice = null;
    },
    /**
     * Adds new FiksnaStavka to list FiksneStavke
     */
    add_new_fiksna(){
      this.novi_troskovnik_temp.fiksne_stavke.push({date_picker_open:false, date_picker_open_review:false, datum:moment(new Date(Date.now())).format('YYYY-MM-DD'),opis:'', tbrovi:'', iznos:0})
    },
    /**
     * Return Date in DD.MM.YYYY from String
     * @param {String} date 
     */
    getDate(date){
      return moment(date).format("DD.MM.YYYY.");
    },
    /**
     * Scrolls to element with ID here
     * @param {HTML-ID} here 
     */
    scrollToEl(here){
      setTimeout(() => {
        document.getElementById(here).scrollIntoView();
      }, 10);
    },
    /**
     * Closes tariff popup
     */
    closePopupAnim(){
      gsap.to(".entry-troskovnik", 0, { pointerEvents: "auto" });
      gsap.to(".mainH", 0, { overflow: "auto" });
      gsap.to(".entry-troskovnik", 0.5, {filter: "none",opacity: 1,});
      this.chosen_row = null;
    },
  },
  watch:{
    "novi_troskovnik_temp.vat_percentage": function(){
        this.novi_troskovnik_temp.vat_percentage = this.novi_troskovnik_temp.vat_percentage.toString().replace(/[^0-9]/g, "");
        if (this.novi_troskovnik_temp.vat_percentage === "") {
            this.novi_troskovnik_temp.vat_percentage = "0";
        }
        if (this.novi_troskovnik_temp.vat_percentage.length > 1 && this.novi_troskovnik_temp.vat_percentage[0] == "0") {
            this.novi_troskovnik_temp.vat_percentage = this.novi_troskovnik_temp.vat_percentage.slice(1);
        }
    },
    "novi_troskovnik_temp.vat_active":function () {
      if (this.novi_troskovnik_temp.vat_active) {
        this.novi_troskovnik_temp.vat_percentage = 25;
      }
      else{
        this.novi_troskovnik_temp.vat_percentage = 0;
      }
    },
    /**
     * Watches popup for closing
     */
    popup_open:function () {
      if (!this.popup_open) {
        this.closePopupAnim();
      }
    }, 
    /**
     * Watches chosen spis and sets data for various elements depending on chosen spis
     */
    "novi_troskovnik_temp.chosen_spis": {
      handler: function () {
        if (this.predmet_info.spis != undefined) {
          let chosen_sp = this.predmet_info.spis.find((sp)=>sp.id_spis == this.novi_troskovnik_temp.chosen_spis.non_int_id);
          this.novi_troskovnik_temp.nadlezno_tijelo.value = chosen_sp.institucija != null ? chosen_sp.institucija.naziv : '';
          this.novi_troskovnik_temp.poslBr.value = chosen_sp.posl_br != null ? chosen_sp.posl_br : '';
        }
      },
      deep:true,
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken 
    console.log(this.$store.state.edit_troskovnik_data);
    if (this.$store.state.edit_troskovnik_data && (this.$store.state.edit_troskovnik_data.vat_percentage == undefined || this.$store.state.edit_troskovnik_data.vat_percentage == null)) {
        this.$set(this.$store.state.edit_troskovnik_data,"vat_percentage","25")
        this.$set(this.$store.state.edit_troskovnik_data,"vat_active",true)
    }
    /**
     * Fetches all currencies data
     */
    await financije.getAllCurrency().then((resp) => {
      this.valute = resp.data;
    })

    /**
     * Fetches all folder types (Troškovnici, Nalozi, Ostale)
     */
    await financije.getFirstLevelFolders(this.$route.params.uid).then((resp)=>{
      this.first_level_folders = resp.data;
      if (this.$store.state.edit_troskovnik_data == null) {
        this.novi_troskovnik_temp.tip_dokumenta.non_int_id = this.first_level_folders[2].id;
      }
    })
    /**
     * Fetches whole sifarnik
     */
    await sifarnik.getAllSifra().then((resp) => {
      let simplified_resp = resp.data.all_sifra
            this.single_row_sifra = resp.data.all_sifra
            console.log(simplified_resp);
            let main_list = simplified_resp.filter((p) => p.parrent_id == null);
            main_list.forEach((p) => {
                p["children"] = this.getAllChildren(simplified_resp, p.uid)
            })
            this.radnje = (main_list)
    })
    await predmet_hand.getAllServiceType().then((resp) => {
      console.log(resp.data.services)
      this.service_types = resp.data.services;
      // this.radnje=resp.data;
      
      // console.log(resp.data);
    })
    await financije.getBillingTypes().then((resp) => {
      this.vrste_naplate = resp.data;
      // this.radnje=resp.data;
      
      // console.log(resp.data);
    })
    await predmet_hand.getSingle(this.$route.params.uid, this.$store.state.logged_in_user.uid).then(async (response) => {
      let all_together = 
        response.data.all_info_predmet.predmet_info
        this.predmet_info = all_together;
        all_together.spis.map((spis)=>this.spisList.push({naziv:spis.ime, id:spis.id_spis}));
        let nositelj = this.predmet_info.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2);
        let nositelj_name = nositelj != undefined && nositelj != null ? nositelj.odvjetnik.ime +' '+nositelj.odvjetnik.prezime : '';
        this.team_members = this.predmet_info.predmet_odvjetnik_connector.map((el)=>{
          return {
            'is_fiz':true,
            'link':el.odvjetnik.uid,
            'value':el.odvjetnik.ime+' '+el.odvjetnik.prezime,
            'tenance_mail':el.odvjetnik.tenance_email,
          }
        })

        /**
         * Sets data if currently editing existing cost sheet
         */
        if (this.$store.state.edit_troskovnik_data == null) {
          this.novi_troskovnik_temp.punomoćnik_osoba =  nositelj_name;
          this.$refs.vezaniSpis.$data.non_int_id = this.spisList[0].id
          this.novi_troskovnik_temp.VPS.input_value = this.predmet_info.VPS != null ? this.predmet_info.VPS : 0;
          this.novi_troskovnik_temp.nadlezno_tijelo.value = this.predmet_info.spis[0].institucija != null ? this.predmet_info.spis[0].institucija.naziv : '';
          this.novi_troskovnik_temp.poslBr.value = this.predmet_info.spis[0].posl_br != null ? this.predmet_info.spis[0].posl_br : '';
          this.novi_troskovnik_temp.stranke = this.predmet_info.connect_fiz_stranka.map(el=>{return {'name':el.fizicka_osoba.ime+' '+el.fizicka_osoba.prezime,'details':`${el.fizicka_osoba.oib != null && el.fizicka_osoba.oib != '' ? 'OIB:'+el.fizicka_osoba.oib+',\n':''}${el.fizicka_osoba.adresa!=null && el.fizicka_osoba.adresa.length!=0 ? this.$t("forms.cost_sheet.adresa")+el.fizicka_osoba.adresa[0].adresa+', '+ el.fizicka_osoba.adresa[0].grad+', '+ el.fizicka_osoba.adresa[0].post_br+', '+ el.fizicka_osoba.adresa[0].drzava:''}`}})
          this.novi_troskovnik_temp.stranke = this.novi_troskovnik_temp.stranke.concat(this.predmet_info.prav_connect_stranka.map(el=>{
            return {'name':el.pravna_osoba.ime,'details':`${el.pravna_osoba.oib != null && el.pravna_osoba.oib != '' ? 'OIB:'+el.pravna_osoba.oib+',\n':''}${el.pravna_osoba.adresa!=null && el.pravna_osoba.adresa.length!=0 ? this.$t("forms.cost_sheet.adresa")+el.pravna_osoba.adresa[0].adresa+', '+ el.pravna_osoba.adresa[0].grad+', '+ el.pravna_osoba.adresa[0].post_br+', '+ el.pravna_osoba.adresa[0].drzava:''}`}
          }))
          if (this.novi_troskovnik_temp.stranke.length==0) {
            this.novi_troskovnik_temp.stranke.push({
              'name':'',
              'details':'',
            })
          }
          this.novi_troskovnik_temp.uspjeh.uspjeh_value =  this.predmet_info.VPS != null ? this.predmet_info.VPS : '';
          this.novi_troskovnik_temp.protustranke = this.predmet_info.connect_fiz_protustranka.map(el=>{return {'name':el.fizicka_osoba.ime+' '+el.fizicka_osoba.prezime,'details':`${el.fizicka_osoba.oib != null && el.fizicka_osoba.oib != '' ? 'OIB:'+el.fizicka_osoba.oib+',\n':''}${el.fizicka_osoba.adresa!=null && el.fizicka_osoba.adresa.length!=0 ? this.$t("forms.cost_sheet.adresa")+el.fizicka_osoba.adresa[0].adresa+', '+ el.fizicka_osoba.adresa[0].grad+', '+ el.fizicka_osoba.adresa[0].post_br+', '+ el.fizicka_osoba.adresa[0].drzava:''}`}})
          this.novi_troskovnik_temp.protustranke = this.novi_troskovnik_temp.protustranke.concat(this.predmet_info.prav_connect_protustranka.map(el=>{return {'name':el.pravna_osoba.ime,'details':`${el.pravna_osoba.oib != null && el.pravna_osoba.oib != '' ? 'OIB:'+el.pravna_osoba.oib+',\n':''}${el.pravna_osoba.adresa!=null && el.pravna_osoba.adresa.length!=0 ? this.$t("forms.cost_sheet.adresa")+el.pravna_osoba.adresa[0].adresa+', '+ el.pravna_osoba.adresa[0].grad+', '+ el.pravna_osoba.adresa[0].post_br+', '+ el.pravna_osoba.adresa[0].drzava:''}`}}))
        }

        if(this.$store.state.edit_troskovnik_data == null || this.novi_troskovnik_temp.oznaka.value == ''){
          this.novi_troskovnik_temp.oznaka.value = `${this.predmet_info.broj_predmeta} - ${nositelj_name.split(' ').map((name)=>name.length>0?name[0]:'').join('')}`;
          if (this.$store.state.logged_in_user.uid != nositelj.odvjetnik.uid) {
            await osoba.getOdvjetnikShort(this.$store.state.logged_in_user.uid).then((resp)=>{
              const person = resp.data.ime+' '+resp.data.prezime;
              this.novi_troskovnik_temp.oznaka.value+=`/${person.split(' ').map((name)=>name.length>0?name[0]:'').join('')}`
            })
          }
        }
      });
      /**
       * Sets data if billing type is hourly rate(satnica)
       */
      if (this.$store.state.edit_troskovnik_data && this.$store.state.edit_troskovnik_data.vrsta_naplate.ID == 4 && !this.$store.state.troskovnik_unosobed_changes) {
        await financije.getBreakdown(this.$store.state.edit_troskovnik_data.id_troskovnik).then((resp) => {
          console.log("Got breakdown",resp.data);
          const breakdown = resp.data;
          breakdown.forEach((b)=>{
            var stavka = {
              local_id: b.local_id, 
              service_type_id:b.service_type_id, 
              belonging_satnica_id: b.belonging_satnica_id,
              date_picker_open:false, 
              date:moment(new Date(b.date)).format('YYYY-MM-DD'), 
              description:b.description, 
              osobe:{results_final: b.odvjetnik ? {name:`${b.odvjetnik.ime} ${b.odvjetnik.prezime}`,uid:b.odvjetnik.uid} : {name:"",uid:""}},
              multiple_odvjetnik :{results_final: b.multiple_odvjetnik},
              satnica:b.satnica, time_h:b.time_h, time_min:b.time_min, iznos:0, vat_iznos:0
            }
            this.breakdown.push(stavka)
            this.$refs.breakdown.calculateIznos(stavka)
          })
        });
      }
  },
  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-currency-input": formCurrencyInput,
    "form-checkbox": formCheckbox,
    TroskovnikElement,
    InvalidElementsList,
    DataLoader,
    SifrarnikPopup,
    TroskovnikOsobeInput,
    TroskovnikBreakdown,
    TroskovnikSatnica
},

  mounted() {
    document.body.classList.add("new-entry");

    this.setTextareaAutoHeight();
    //postavi inicijalni datum na današnji
    this.novi_troskovnik_temp.time_created = moment(Date.now()).format('yyyy-MM-DD');
    //provjera da editiram već kreirani troškovnik (postoji mogucnost da se samo vraćam s report forme)
    if (this.$store.state.edit_troskovnik_data != null && this.$store.state.edit_troskovnik_data.id_troskovnik != undefined) {
      this.editing_created = true;
    }

    //ako editiram postojeći poveži sve podatke
    if (this.$store.state.edit_troskovnik_data != null) {
      this.novi_troskovnik_temp = this.$store.state.edit_troskovnik_data;
      this.$refs.vrstaNaplate.$data.ID = this.$store.state.edit_troskovnik_data.vrsta_naplate.ID;
      this.$refs.naslov.$data.value = this.$store.state.edit_troskovnik_data.naslov.value;
      this.$refs.valuta.$data.drop_value = this.$store.state.edit_troskovnik_data.VPS.drop_value;
      this.$refs.valuta.$data.input_value = this.$store.state.edit_troskovnik_data.VPS.input_value;
      this.$refs.poslBr.$data.value = this.$store.state.edit_troskovnik_data.poslBr.value;
      if(this.$store.state.edit_troskovnik_data.oznaka != undefined){
        this.$refs.oznaka.$data.value = this.$store.state.edit_troskovnik_data.oznaka.value;
      }
      if(this.$store.state.edit_troskovnik_data.opis_usluge != undefined){
        this.$refs.opisUsluge.$data.value = this.$store.state.edit_troskovnik_data.opis_usluge.value;
      }
      if(this.$store.state.edit_troskovnik_data.napomene != undefined){
        this.$refs.napomene.$data.value = this.$store.state.edit_troskovnik_data.napomene.value;
      }
      if(this.$store.state.edit_troskovnik_data.dospijece != undefined){
        this.$refs.dospijece.$data.value = this.$store.state.edit_troskovnik_data.dospijece.value;
      }
      //breakdown poveži ovdje samo ako se vraćam s forme
      if(this.$store.state.breakdown_satnice && this.$store.state.breakdown_satnice.length>0 && this.$store.state.troskovnik_unsaved_changes){
        this.breakdown = this.$store.state.breakdown_satnice;
        this.breakdown = this.breakdown.sort((a,b)=>new Date(a.date) - new Date(b.date) );
      }
      this.$refs.nadlezno.$data.value = this.$store.state.edit_troskovnik_data.nadlezno_tijelo.value;
      this.$refs.vezaniSpis.$data.non_int_id = this.$store.state.edit_troskovnik_data.chosen_spis.non_int_id;
      this.$refs.tipDokumenta.$data.non_int_id = this.$store.state.edit_troskovnik_data.tip_dokumenta.non_int_id;
      this.$refs.targetiranaSkupina.$data.ID = this.$store.state.edit_troskovnik_data.targetirana_skupina.ID;
      this.novi_troskovnik_temp.time_created = this.$store.state.troskovnik_data.time_created != undefined ? moment(this.$store.state.troskovnik_data.time_created).format('yyyy-MM-DD') : moment(this.novi_troskovnik_temp.time_created).format('yyyy-MM-DD');
    }
    this.novi_troskovnik_temp.vrsta_naplate = this.$refs.vrstaNaplate.$data;
    this.novi_troskovnik_temp.naslov = this.$refs.naslov.$data;
    this.novi_troskovnik_temp.VPS = this.$refs.valuta.$data;
    this.novi_troskovnik_temp.poslBr = this.$refs.poslBr.$data;
    this.novi_troskovnik_temp.opis_usluge = this.$refs.opisUsluge.$data;
    this.novi_troskovnik_temp.napomene = this.$refs.napomene.$data;
    this.novi_troskovnik_temp.dospijece = this.$refs.dospijece.$data;
    this.novi_troskovnik_temp.nadlezno_tijelo = this.$refs.nadlezno.$data;
    this.novi_troskovnik_temp.chosen_spis = this.$refs.vezaniSpis.$data;
    this.novi_troskovnik_temp.tip_dokumenta = this.$refs.tipDokumenta.$data;
    this.novi_troskovnik_temp.targetirana_skupina = this.$refs.targetiranaSkupina.$data;
    this.novi_troskovnik_temp.oznaka = this.$refs.oznaka.$data;

    // Auto-preview AI-generated documents
    if (this.$store.state.troskovnik_auto_preview) {
      // Clear the flag
      this.$store.state.troskovnik_auto_preview = false;

      // Wait for all refs to be ready, then automatically show preview
      this.$nextTick(() => {
        this.createPdf();
      });
    }

    //close anim
    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
  },
  destroyed() {
    document.body.classList.remove("new-entry");
    $(".entry-exit").off();
  },
};
</script>
